// src/pages/categoryItem/components/ChildrenList/ChildrenList.tsx

import React from "react";
import { Link } from "react-router-dom";
import { CategoryInterface } from "../../../../common/types/types";
import { getImageUri } from "../../../../common/utils/functions/getImageUri";
import styles from "./ChildrenList.module.scss";

type Props = {
  children: CategoryInterface[];
};

export default function ChildrenList({ children }: Props) {
  if (!children || children.length === 0) return null;

  return (
    <div className={styles.wrapper}>
      <h3 className={styles.title}>Подкатегории</h3>
      <ul className={styles.list}>
        {children.map((child) => (
          <li key={child.id} className={styles.item}>
            <Link
              to={`/category/${child.id}`}
              className={styles.link}
              aria-label={`Перейти в категорию ${child.name}`}
            >
              {child.files?.[0] ? (
                <img
                  src={`${getImageUri()}${child.files[0]}`}
                  alt={child.name}
                  className={styles.image}
                />
              ) : (
                <div className={styles.imagePlaceholder} />
              )}
              <span className={styles.name}>{child.name}</span>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
